import { render, staticRenderFns } from "./OrderCheck.vue?vue&type=template&id=dbdf7d48&scoped=true&"
import script from "./OrderCheck.vue?vue&type=script&lang=js&"
export * from "./OrderCheck.vue?vue&type=script&lang=js&"
import style0 from "./OrderCheck.vue?vue&type=style&index=0&id=dbdf7d48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdf7d48",
  null
  
)

export default component.exports